import { ArrowRight, BookOpen, Check } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Empty, Status } from '../components/common';
import { useLab } from '../lib/service';
import {} from '../shared';
import { useSeries } from './context';

/** The story and visual bibles plus the season plan, once one exists. */
export function BlueprintTab() {
  const {
    detail: d,
    project: p,
    controlsDisabled,
    setTab,
    direction,
    setDirection,
    act,
  } = useSeries();
  const lab = useLab();
  return (
    <>
      {!d.episodes.length ? (
        <Empty
          title="A season worth staying for"
          text="Approve the pitch to develop the full season arc and story rules."
        />
      ) : (
        <div className="blueprint-layout">
          <div>
            <div className="section-heading">
              <h2>The season arc</h2>
              <span className="muted">
                {d.episodes.length} episodes planned · rendered on request
              </span>
            </div>
            <div className="episode-outline">
              {d.episodes.map((e) => (
                <div key={e._id}>
                  <span>{String(e.number).padStart(2, '0')}</span>
                  <div>
                    <h3>{e.title}</h3>
                    <p>{e.synopsis}</p>
                    <small>HOOK · {e.cliffhanger}</small>
                  </div>
                  <Status value={e.status} />
                </div>
              ))}
            </div>
          </div>
          <aside>
            <div className="paper-panel">
              <BookOpen size={20} />
              <h3>Story canon</h3>
              <p className="muted">The facts every episode must respect.</p>
              {d.canon.map((f, i) => (
                <div className="canon-fact" key={i}>
                  <Check size={13} />
                  <span>
                    {f.subject} {f.predicate} {f.value}
                    <small>Known from episode {f.knownFrom}</small>
                  </span>
                </div>
              ))}
            </div>
            <div className="paper-panel">
              <h3>Visual direction</h3>
              <textarea
                aria-label="Visual direction"
                value={direction || p.visualDirection}
                onChange={(e) => setDirection(e.target.value)}
                disabled={p.castLocked}
                rows={4}
              />
              <Button
                variant="outline"
                disabled={controlsDisabled || p.castLocked || !direction}
                onClick={() => void act(() => lab.setDirection(p._id, direction))}
              >
                Save direction
              </Button>
            </div>
            <Button className="full-width" onClick={() => setTab('Cast')}>
              Find your cast
              <ArrowRight size={16} />
            </Button>
          </aside>
        </div>
      )}
    </>
  );
}
